/**
 * @module BannerList
 * @description
 */
import React, { FC, useState } from 'react';
import Component from 'ui/components/Component';
import { trackEvent } from 'ui/js/helpers/tracking';
import styles from './styles/BannerDropdownList.module.css';

interface ListItem {
  icon: string;
  title: string | JSX.Element;
  details: string | JSX.Element;
}

interface Props {
  title?: string | JSX.Element;
  items?: ListItem[];
  theme?: 'Dark' | 'Blue' | 'Light';
  position?: string;
}

const defaultItems = [
  {
    icon: 'wrench',
    title: 'Free installation',
    details: <>For a limited time, get free expert installation &mdash;a $95 value</>
  },
  {
    icon: 'router',
    title: 'Wi-Fi router included',
    details: 'Up to $169 value if purchased separately'
    },
  {
    icon: 'money-sign',
    title: 'Auto Pay discount',
    details: 'Save $5/mo for 24 months, $120 over 2 years'
  },
];

const BannerDropdownList: FC<Props> = ( { ...props } ) => {
  const {
    title = 'Included in every plan:',
    items = defaultItems,
    theme = 'Light',
    position = 'BANNER DROPDOWN LIST'
  } = props;

  const isAltTheme = theme !== null;
  const themeClass = `is${ theme }`;
  const [ expanded, setExpanded ] = useState( false );

  const handleClick = () => {
    setExpanded( ! expanded );

    const data = {
      elementType: 'BANNER',
      position,
      text: 'Learn more',
      actionOutcome: 'EXPAND / COLLAPSE LIST'
    };

    trackEvent( { action: 'elementClicked', data, event } );
  }

  return (
    <Component
      inContainer
      className={ `
        ${ styles.component }
        ${ isAltTheme && styles[ themeClass ] }
        ${ title && styles.withTitle }
      ` }
      data-expanded={ expanded }
    >
      <>
        <div className={ styles.body }>
          { title && <h2 className={ styles.title }>{ title }</h2> }

          <ul className={ styles.ul }>
            { items.map( ( item: ListItem, index: number ) => (
              <li key={ index } className={ styles.li }>
                <div
                  className={ styles.liTitle }
                  style={ {
                  // @ts-ignore-next-line
                  '--icon': `var( --icon-${ item.icon } )`,
                } }
                >
                  { item.title }
                </div>
                <div className={ styles.liContent }>{ item.details }</div>
              </li>
            ) ) }
          </ul>
        </div>
        <div className={ styles.footer }>
          <button
            type="button"
            role="button"
            className={ styles.expandButton }
            onClick={ handleClick }
          >
            <span>Learn more</span>
          </button>
        </div>
      </>
    </Component>
  );
};

BannerDropdownList.displayName = 'BannerDropdownList';

export default BannerDropdownList;
